module.exports = __webpack_public_path__ + "assets/img/menu-progress.73b74b82.svg";